<div class="create-process float-right" id="btn_new_process">
    <app-spinner 
    [isEnable] = "isSpinnerEnable"
    loaderClass="center-spinner-loader"></app-spinner>
  <div (click)="$event.stopPropagation()" class="btn-group p-t-10" dropdown>
    <div id="button-action" class="action" dropdownToggle aria-controls="dropdown-action">
      <span></span>
    </div>
    <div id="dropdown-action" *dropdownMenu class="dropdown-menu" aria-labelledby="button-action">
        <div slimScroll alwaysVisible="true" width="auto" height="440px" size="3px">
            <div *ngIf="isSelectedProcesses" (click)="duplicate()" class="m-b-5">Create duplicates of the selected processes (up to selection criteria)</div>
            <div *ngIf="isSelectedProcesses" (click)="sendHrSummary()" class="m-b-5">
                Send notification on process changes
            </div>
            <hr />
            <div class="d-flex" (click)="appraiseeBlockVisible = !appraiseeBlockVisible"><span class="btn-expand" [class.btn-expand-down]="appraiseeBlockVisible"></span>Notify appraisee</div> 
            <div *ngIf="appraiseeBlockVisible" class="pl-4">
                <div (click)="openModal(approveModal, notificationType.ActionAppraiseeNotification)" class="m-b-5">Notify appraisee on the need for action on the process</div>
                <div (click)="openModal(approveModal, notificationType.ActionAppraiseeReminder)" class="m-b-5">Remind appraisee on the need for action on the process</div>
                <div (click)="openModal(approveModal, notificationType.RespondentsConfirmedByHrAppraiseeNotification)" class="m-b-5">Notify appraisee that HR confirmed respondents</div>
                <div (click)="openModal(approveModal, notificationType.EndProcessAppraiseeNotification)" class="m-b-10 m-t-5">Notify appraisee about end of the process</div>
            </div>
            <div class="d-flex" (click)="respondentBlockVisible = !respondentBlockVisible"><span class="btn-expand" [class.btn-expand-down]="respondentBlockVisible"></span>Notify respondent</div> 
            <div *ngIf="respondentBlockVisible" class="pl-4">
                <div (click)="openModal(approveModal, notificationType.NewSurveyRespondentNotification)" class="m-b-5">Notify respondent about new survey</div>
                <div (click)="openModal(approveModal, notificationType.NewSurveyRespondentReminder)">Remind respondent about new survey</div>
            </div>
            <div class="d-flex" (click)="pmBlockVisible = !pmBlockVisible"><span class="btn-expand" [class.btn-expand-down]="pmBlockVisible"></span>Notify PM</div> 
            <div *ngIf="pmBlockVisible" class="pl-4">
                <div (click)="openModal(approveModal, notificationType.ProcessStartPmNotification)" class="m-b-5">Notify PM about start of the process</div>
                <div (click)="openModal(approveModal, notificationType.EndProcessPmNotification)" class="m-b-5">Notify PM about end of the process</div>
                <div (click)="openModal(approveModal, notificationType.RespondentConfirmPmReminder)" class="m-b-5">Remind PM to confirm respondents</div>
                <div (click)="openModal(approveModal, notificationType.RespondentsConfirmedByHrPmNotification)">Notify PM that HR confirmed respondents</div>
            </div>
            <div class="d-flex" *ngIf="!hrBlockHide" (click)="hrBlockVisible = !hrBlockVisible"><span class="btn-expand" [class.btn-expand-down]="hrBlockVisible"></span>Notify HR</div> 
            <div *ngIf="hrBlockVisible" class="pl-4">
                <div (click)="openModal(approveModal, notificationType.RespondentConfirmHrNotification)" class="m-b-5">Notify HR to confirm respondents</div>
                <div (click)="openModal(approveModal, notificationType.RespondentConfirmHrReminder)" class="m-b-5">Remind HR to confirm respondents</div>
                <div (click)="openModal(approveModal, notificationType.EndProcessHrNotification)">Notify HR about end of the process</div>            
            </div>
            <hr />
            <div *ngIf="isSelectedActive" (click)="onChangeDeadlineClicked()" class="m-b-5">Change deadline</div>
            <div *ngIf="isSelectedProcesses" (click)="downloadProcessesInfo()" class="m-b-5">Download processes info</div>
            <div class="d-flex align-items-center">
                <span *ngIf="isSelectedProcesses && isOfTheSameSurvey" class="btn-download" (click)="downloadExcelReport()">
                    Download process report
                </span>
              </div>
        </div>
    </div>
  </div>
</div>
<ng-template #approveModal>
  <div>
    <div class="modal-body">
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="d-flex justify-content-center flex-column" style="min-height: 85px;">
        <div>
          Do you really want to send notifications?
        </div>
      </div>
      <div class="btn-modal">
        <span (click)="sendToAll()">Send to all</span>
        <span (click)="sendToSelected()">Send to selected</span>
      </div>
    </div>
  </div>
</ng-template>